var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSetupIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.25rem",
    height: "1.25rem",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "x06p3o5hha"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 558",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61680"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11289",
    style: {
      clipPath: "url(#x06p3o5hha)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13558"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9389",
    d: "M621.048 390.8c-1.133 0-2.266.014-3.4 0a2.986 2.986 0 0 1-2.674-1.539q-1.749-2.982-3.456-5.99a2.952 2.952 0 0 1 .009-3.083q1.7-2.986 3.436-5.954a2.988 2.988 0 0 1 2.705-1.556q3.42-.022 6.84 0a2.988 2.988 0 0 1 2.706 1.556q1.736 2.967 3.436 5.955a2.977 2.977 0 0 1-.009 3.12q-1.695 2.967-3.416 5.919a3.022 3.022 0 0 1-2.737 1.575c-1.147.01-2.293-.003-3.44-.003zm.041-16.833h-3.4a1.774 1.774 0 0 0-1.627.944l-3.4 5.882a1.772 1.772 0 0 0 0 1.881l3.4 5.882a1.772 1.772 0 0 0 1.627.945h6.8a1.773 1.773 0 0 0 1.627-.944l3.4-5.882a1.775 1.775 0 0 0 0-1.881q-1.695-2.943-3.395-5.882a1.773 1.773 0 0 0-1.627-.944l-3.405.002z",
    transform: "translate(-611.088 -371.738)",
    style: {
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9390",
    d: "M631.9 387.069a3.825 3.825 0 1 1-3.855 3.793 3.807 3.807 0 0 1 3.855-3.793zm-.042 1.3a2.527 2.527 0 1 0 2.537 2.537 2.512 2.512 0 0 0-2.539-2.539z",
    transform: "translate(-621.865 -380.893)",
    style: {
      strokeWidth: ".5px"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetupIcon);
export default __webpack_public_path__ + "static/media/SetupIcon.c7bb691e53a04d03577e89ab93a230dd.svg";
export { ForwardRef as ReactComponent };